import { useAuth } from "@/providers";
import { Invocations } from "@/shared/components/actions/Invocations";

import { useSessionOutletContext } from "./useSessionOutletContext";

/**
 * The Actions tab of a session's page: the shared invocations list, scoped to the invocations
 * whose input names this session by ID.
 */
export function SessionInvocations() {
  const { session } = useSessionOutletContext();
  const { currentOrganization } = useAuth();
  return (
    <Invocations
      sessionId={session.session_id}
      currentOrg={currentOrganization}
    />
  );
}
